import { OccConfig } from "@spartacus/core";

export const customDefaultOccProductConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        productSearch: 'products/search?fields=products(baseProduct,code,isCachePrice,classificationClasses,isNewIn,configurable,description,discountPriceData,images(FULL),interval,maxQuantity,minQuantity,multidimensional,name,obsoleteFlag,priceRange,quotationFlag,stock(FULL),url,volumePricesFlag),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
      }
    }
  }
}